import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="w-full bg-primary-500 py-12 md:py-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-3">
          准备好开始了吗？
        </h2>
        <p className="text-sm text-background-50/80 max-w-[560px] mx-auto mb-6">
          立即通过 kaiyun.con 找到开云平台的正确入口，开启您的体验之旅。我们为您整理了最全面的导航和使用指南。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/pingtai-daohang"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-600 font-medium rounded-md hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-compass-3-line text-base w-5 h-5 flex items-center justify-center"></i>
            开始导航
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-background-50 font-medium rounded-md hover:bg-primary-700 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-information-line text-base w-5 h-5 flex items-center justify-center"></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}